import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { advancedScriptRequirements } from 'constants/advanced';

// components
import DoesNotMeetRequirements from './DoesNotMeetRequirements';
import MeetsRequirements from './MeetsRequirements';
import AwaitingRequirementsCheck from './AwaitingRequirementsCheck';

const baseString = 'vra-review-harvest-history';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-create-script-screen': true
});

let ReviewHarvestHistory = ({
  advancedScriptRequirementsMatch,
  cropList,
  historyRows,
  isAppMode,
  manualRoute,
  onClickImportLink,
  onClickManualScriptTrigger,
  onSelectCropForSeason,
  onSelectDateForSeason,
  onToggleLayerInclusion,
  upgradePath
}) => {
  const contentOptions = {
    [advancedScriptRequirements.DOES_NOT_MEET]: (
      <DoesNotMeetRequirements
        isAppMode={isAppMode}
        onClickImportLink={onClickImportLink}
        onClickManualScriptTrigger={() => onClickManualScriptTrigger({ manualRoute })}
        upgradePath={upgradePath}
      />
    ),
    [advancedScriptRequirements.PENDING]: (
      <AwaitingRequirementsCheck
        advancedScriptRequirementsMatch={advancedScriptRequirementsMatch}
        cropList={cropList}
        historyRows={historyRows}
        onClickImportLink={onClickImportLink}
        onSelectCropForSeason={onSelectCropForSeason}
        onToggleLayerInclusion={onToggleLayerInclusion}
      />
    ),
    default: (
      <MeetsRequirements
        advancedScriptRequirementsMatch={advancedScriptRequirementsMatch}
        cropList={cropList}
        historyRows={historyRows}
        isAppMode={isAppMode}
        onSelectCropForSeason={onSelectCropForSeason}
        onSelectDateForSeason={onSelectDateForSeason}
        onToggleLayerInclusion={onToggleLayerInclusion}
      />
    )
  };
  const content = contentOptions[advancedScriptRequirementsMatch] || contentOptions.default;

  return (
    <section className={classString} data-test-id={`${baseString}`}>
      {content}
    </section>
  );
};

ReviewHarvestHistory.propTypes = {
  advancedScriptRequirementsMatch: propTypes.oneOf(Object.values(advancedScriptRequirements)),
  cropList: propTypes.object.isRequired,
  historyRows: propTypes.array.isRequired,
  isAppMode: propTypes.bool.isRequired,
  manualRoute: propTypes.string.isRequired,
  onClickImportLink: propTypes.func.isRequired,
  onClickManualScriptTrigger: propTypes.func.isRequired,
  onSelectCropForSeason: propTypes.func.isRequired,
  onSelectDateForSeason: propTypes.func.isRequired,
  onToggleLayerInclusion: propTypes.func.isRequired,
  upgradePath: propTypes.string.isRequired
};

export default ReviewHarvestHistory;
